function isMantineColorScheme(value) {
  return value === "auto" || value === "dark" || value === "light";
}

export { isMantineColorScheme };